import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeSinceComponent } from './time-since.component';

@NgModule({
  declarations: [TimeSinceComponent],
  imports: [CommonModule],
  exports: [TimeSinceComponent],
})
export class TimeSinceModule {}
